(() => {
const root=document.querySelector('[data-dna-reader]');if(!root||root.dataset.ready)return;root.dataset.ready='true';
const main=root.closest('main'),items=[];
[...main.children].filter(el=>el.classList.contains('shopify-section')&&!el.contains(root)).forEach(section=>{
const heading=[...section.querySelectorAll('h1,h2,h3,.multicolumn-card__title')].find(el=>el.textContent.trim());
const nodes=[...section.querySelectorAll('h1,h2,h3,p')].filter(el=>el.textContent.trim());
const text=nodes.map(el=>el.textContent.trim()).join('. ');
if(heading&&text)items.push({section,sections:[section],heading,title:heading.textContent.trim(),text});
else if(text&&items.length){items[items.length-1].text+='. '+text;items[items.length-1].sections.push(section)}
});
let chapterNumber=0;
items.forEach(item=>{
if(item.section.querySelector('h1'))return;
const chapter=document.createElement('details'),summary=document.createElement('summary'),number=document.createElement('span'),title=document.createElement('span'),plus=document.createElement('span'),body=document.createElement('div');
chapter.className='wq-dna-chapter';chapter.id='dna-chapter-'+(++chapterNumber);
number.className='wq-dna-chapter-number';number.textContent=String(chapterNumber).padStart(2,'0');number.setAttribute('aria-hidden','true');
title.textContent=item.title;plus.className='wq-dna-chapter-plus';plus.textContent='+';plus.setAttribute('aria-hidden','true');
summary.append(number,title,plus);body.className='wq-dna-chapter-body';chapter.append(summary,body);item.section.before(chapter);
const prose=document.createElement('div'),gallery=document.createElement('div');prose.className='wq-dna-prose';gallery.className='wq-dna-photos';
item.sections.forEach(section=>{
const candidates=[...section.querySelectorAll('.rte,h2,h3,h4,.multicolumn-card__title,.button-group')];
candidates.filter(el=>!candidates.some(parent=>parent!==el&&parent.contains(el))).forEach(el=>{if(el!==item.heading)prose.append(el)});
[...section.querySelectorAll('picture,img')].filter(el=>el.tagName==='PICTURE'||!el.closest('picture')).forEach(el=>gallery.append(el));
section.remove();
});
body.append(prose);if(gallery.children.length){body.append(gallery);body.classList.add('wq-dna-has-photos')}item.chapter=chapter;
});
root.querySelector('[data-dna-contents]').hidden=true;
const revealHash=()=>{const target=document.getElementById(decodeURIComponent(location.hash.slice(1)));const chapter=target?.closest('.wq-dna-chapter');if(chapter)chapter.open=true};
revealHash();window.addEventListener('hashchange',revealHash);
const audio=root.querySelector('[data-dna-recording]'),panel=root.querySelector('[data-dna-audio]');
if(!audio||!panel)return;
const labels=JSON.parse(root.querySelector('[data-dna-labels]').textContent);
const play=panel.querySelector('[data-dna-play]'),pause=panel.querySelector('[data-dna-pause]'),stop=panel.querySelector('[data-dna-stop]'),status=panel.querySelector('[data-dna-status]'),pauseLabel=pause.querySelector('span');
let active=false,run=0;
const sync=()=>{
play.disabled=active;pause.disabled=!active;stop.disabled=!active;
const paused=active&&audio.paused;
pauseLabel.textContent=paused?labels.resume:labels.pause;
pause.setAttribute('aria-label',pauseLabel.textContent);
pause.dataset.paused=String(paused);panel.dataset.playing=String(active&&!audio.paused);
};
const fail=()=>{active=false;sync();status.textContent=labels.unavailable;audio.hidden=false};
const start=()=>{const current=++run;active=true;status.textContent='';sync();audio.play().catch(()=>{if(run===current)fail()})};
play.addEventListener('click',()=>{audio.currentTime=0;start()});
pause.addEventListener('click',()=>{if(audio.paused)start();else audio.pause()});
stop.addEventListener('click',()=>{run++;audio.pause();audio.currentTime=0;active=false;status.textContent='';sync()});
audio.addEventListener('play',()=>{active=true;sync()});
audio.addEventListener('pause',sync);
audio.addEventListener('ended',()=>{active=false;sync();status.textContent=labels.finished});
audio.addEventListener('error',fail);
window.addEventListener('pagehide',()=>{run++;audio.pause();active=false;sync()});
audio.hidden=true;panel.hidden=false;sync();
})();
